import React from "react";
import PropTypes from "prop-types";
import * as yup from "yup";

import { FormGroupTitle, FormTextField } from "ui/Form";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import { READ_LICENSES_NAME } from "graphqlQueries/licenses";
import { UPDATE_LICENSE_TEMPLATE } from "graphqlQueries/licenseTemplate";
import { nameValidator } from "validators/commonValidators";

const validation = yup.object({
  name: nameValidator,
});

const fieldsWithPlaceForError = ["name", "description"];

const UpdateLicenseTemplateDialog = ({ licenseInfo, onClose }) => {
  const initialValues = {
    id_license: licenseInfo.id,
    name: licenseInfo.name,
    description: licenseInfo.comment,
  };

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_LICENSE_TEMPLATE}
      refetchQueries={[READ_LICENSES_NAME]}
      initialValues={initialValues}
      validationSchema={validation}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title={`Update License Template ${licenseInfo.name}`}
      submitButtonName="Save"
      className="dialog-default-width"
      onClose={onClose}
    >
      <FormGroupTitle title="License Template information" />
      <FormTextField name="name" label="License name" />
      <FormTextField name="description" label="Comment" />
    </DialogFormWithMutation>
  );
};

UpdateLicenseTemplateDialog.propTypes = {
  licenseInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateLicenseTemplateDialog;
